// src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';
// import SearchBar from '../SearchBar';

const Header = () => {
  return (
    <header className="bg-gray-400 text-white">
      <div className="container mx-auto flex justify-between items-center py-4 px-6">
        {/* Logo */}
        <div className="text-xl font-bold">
          <Link to="/" className="hover:text-gray-200">
            🍴 Cooking Recipes
          </Link>
        </div>

        {/* Navigation */}
        <nav>
          <ul className="flex space-x-6">
            <li>
              <Link to="/" className="hover:text-gray-200">
                Trang chủ
              </Link>
            </li>
            <li>
              <Link to="/search" className="hover:text-gray-200">
                Tìm kiếm
              </Link>
            </li>
          </ul>
        </nav>

        {/* Search Bar */}
        <div className="max-w-md w-full">
          {/* <SearchBar /> */}
        </div>
      </div>
    </header>
  );
};

export default Header;
